import Loader from 'react-loaders'
import { useState, useRef } from 'react'
import { toast } from 'react-toastify'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Contact = () => {
  const form = useRef()

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const { name, email, subject, message } = formData

    if (!name || !email || !message) {
      toast.error("Champs manquants !", {
        position: "top-left",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      })
      return
    }

    try {
      const response = await fetch('/backend/contact_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          // sujet: subject,
          message: `Message de ${name} (${email}) : ${message}`
        })
      })

      if (response.ok) {
        toast.success("Message envoyé !", {
          position: "top-left",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
        })
        // Reset form
        setFormData({ name: '', email: '', subject: '', message: '' })
      } else {
        sendingError()
      }
    } catch (error) {
      console.error("Erreur:", error)
      sendingError()
    }
  }

  const sendingError = () => {
    toast.error("Erreur d'envoi !", {
      position: "top-left",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    })
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', 'e', 'z', ' ', 'm', 'o', 'i']}
              idx={13}
            />
          </h1>
          <div className="contact-form">
            <form ref={form} onSubmit={handleSubmit}>
              <ul>
                <li>
                  <input
                    placeholder="Nom"
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </li>
                <li>
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </li>
                {/* <li>
                  <input
                    placeholder="Sujet"
                    type="text"
                    name="subject"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </li> */}
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="ENVOYER" />
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
